<template>
    <div class="teaser_flags_row">
        <div
            v-for="(f, i) in flags"
            :key="`exemplary-flag-${f.id}`"
            class="row align-items-center flags_row_item">
            <div class="col col-1 text-center">
                <RiskLevelDumpling :value="f.risk" :level="f.risk_level_lite" />
            </div>
            <div class="col col-11 flag_description">
                <h5>
                    {{ f.type }} > {{ f.group }}
                </h5>
                <p v-html="f.desc"/>
            </div>
        </div>
    </div>
</template>

<script>
import RiskLevelDumpling from "@/components/RiskLevelDumpling.vue";
import riskMixin from "@/plugins/riskMixin.js";

export default {
    props: {
        flags: { type: Array, required: true }
    },
    mixins: [riskMixin],
    components: { RiskLevelDumpling },
};
</script>

<style lang="scss">
@use "@/scss/custom";
.teaser_flags_row {
    margin-top: 15px;
    margin-bottom: 15px;

    h4 {
        font-size: 16px;
    }

    h5 {
        font-size: 14px;
        font-weight: 700;
    }

    .flag_description p {
        font-size: 14px;
        margin-bottom: 0px;
    }

    .flags_row_item {
        margin-bottom: 20px;
        background-color: custom.$light-grey;
        padding: 20px;
        border-radius: 20px;

        &:last-of-type {
            margin-bottom: 0px;
        }
    }
}
</style>
